export default __webpack_public_path__ + "static/media/2048.06eeeacd.png";